<script setup>
import { ref } from 'vue'
import axios from 'axios'
import Autocomplete from './components/Autocomplete.vue';

const isLoading = ref(true)
const results = ref([])

axios.get('/wp-json/vegsoc/v1/classes?posts_per_page=-1&minimal=1')
	.then( response => {
		results.value = response.data.items
		isLoading.value = false
	})
  	.catch( error => {
    	console.log(error)
  	})

</script>

<template>
	<Autocomplete :source="results" :isLoading="isLoading" />
</template>